import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as rubrosActions from '../../reducers/rubrosReducer/actions'
import { rubrosDataSelector } from '../../selectors/rubrosSelector'
import * as articuloActions from '../../reducers/articuloReducer/actions'
import { articuloDataSelector } from '../../selectors/articuloSelector'
import * as Notification from '../../components/Common/notification'
import ArticuloGenericoNuevo from '../../components/Articulo/articuloGenericoNuevo'
import { compress, calculateNewSize } from '../../components/Common/imageCompressor'
import { usuarioSelector } from '../../selectors/sessionSelector'


class ArticuloGenericoNuevoContainer extends React.Component{   
    constructor(props){
        super(props)
        
        let idTemporalEdition = 0
        idTemporalEdition= Math.floor(1000 + Math.random() * 9000)


        this.state= {
            update : false,
            currentFiles:{},
            idTemporal: idTemporalEdition,
            errorDescription: {},
            valid: true,
            openModalImagen: false,
            clearState : false,
            pathRecorteActual: undefined,
            imagenOriginal:undefined,
            articulo: {
                nombre: '',
                precio: '',
                idSubrubro: 0,               
                imgSrc: [],               
                codigoInterno: '',
                stock: 0,
                stockGenerico: 0, 
                descripcion: '',
                etiquetas: []
            },
            campoEtiqueta: ''            
        }

        if(this.props.rubros.rubros === undefined) 
            this.props.history.push('/Articulo');
        
        let payload = {};
        payload.id = this.props.match.params.idArticulo
        //idTemporalEdition= Math.floor(1000 + Math.random() * 9000)    
        payload.idTemporalEdition = this.state.idTemporal
        
        if (this.props.match.params.idArticulo !== undefined){
            this.setState({
                update:true
            })
            //this.props.sagaGetSubRubros(this.props.match.params.idArticulo,null,true);
            this.props.sagaGetArticuloCompleto(payload)
        }
        

    }

    componentWillReceiveProps(nextProps){
        if (nextProps.match.params.idArticulo !== undefined && nextProps.dataArticulo.articuloCompleto !== undefined && nextProps.dataSubrubro.subrubros !== undefined){
            
            let newStock = nextProps.dataArticulo.articuloCompleto.stock
            let newStockGenerico = nextProps.dataArticulo.articuloCompleto.stockGenerico
            let imgTemp = nextProps.dataArticulo.articuloCompleto.listaImagenesArticulos
            imgTemp.map(item => {
                if (item.miniatura) {
                    return {
                        ...item,
                        selected: true
                    }
                } else {
                    return item
                }
            })
            
            //let idTemporalEdition = 0

            this.setState({
                ...this.state, 
                articulo: {
                    ...this.state.articulo,
                    stock: newStock,
                    stockGenerico: newStockGenerico, 
                    imgSrc: imgTemp,
                    nombre: nextProps.dataArticulo.articuloCompleto.nombre,
                    precio: nextProps.dataArticulo.articuloCompleto.precioLista,
                    idSubrubro:  nextProps.dataArticulo.articuloCompleto !== undefined ? nextProps.dataArticulo.articuloCompleto.subrubroClass.idSubRubro : 0,
                    idTipoTalle:  nextProps.dataArticulo.articuloCompleto !== undefined ? nextProps.dataArticulo.articuloCompleto.tipoTalle.idTipoTalle : 0,
                    codigoInterno: nextProps.dataArticulo.articuloCompleto.codigoInterno,
                    etiquetas:nextProps.dataArticulo.articuloCompleto.etiquetas ? nextProps.dataArticulo.articuloCompleto.etiquetas : [],
                },
                edicion:true,
                update:true,
                subrubroClear:false,
                idSubRubroInicial:nextProps.dataArticulo.articuloCompleto !== undefined ? nextProps.dataArticulo.articuloCompleto.subrubroClass.idSubRubro : 0,
                updateIdTemporal: false,
                idTemporal: this.state.idTemporal,
                imagenesCargadas: false,
                cantidadImagenesCargadas: 0,
                cantidadImagenesOriginalesCargadas: 0,
                cantidadImagenesStockCargadas: 0,
    
                openModalImagen: false,
                openModalImagenTalleColor: false,
                showBorrarArticuloDialog:false,
                imagenOriginal:undefined,
                imagenTalleColor: undefined,
                currentFiles:{},
                pathRecorteActual: undefined,
                pathTalleColor:undefined,
                indiceTalleColor : undefined,
                idTemporalTalleColor: undefined,
                articuloImagenModal: undefined,
    
                articuloCargado: false,
                stockOriginal: undefined,
                cantidadLlamadasAtemporal: 0,
                usuarioCargado: false
            })
        }
    }

    componentDidUpdate = () => {

        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                }
            })
        }


        if(this.props.dataArticulo.articuloCompleto !== undefined && this.state.articuloCargado === false){
            this.setState({ articuloCargado: true }, this.guardarStockOriginal)
        }

        if(this.props.dataArticulo.articuloCompleto !== undefined && this.state.imagenesCargadas === false){
            this.setState({ imagenesCargadas: true }, this.getImagenesArticulo)
        }
        if(this.props.dataArticulo.articuloCompleto !== undefined && this.props.dataArticulo.cantidadImagenesCargadas !== this.state.cantidadImagenesCargadas){
            this.setState({ cantidadImagenesCargadas: this.props.dataArticulo.cantidadImagenesCargadas }, this.actualizarImagenesArticulo)
        }

        if(this.props.dataArticulo.articuloCompleto !== undefined && this.props.dataArticulo.cantidadImagenesOriginalesCargadas !== this.state.cantidadImagenesOriginalesCargadas){
            this.setState({ cantidadImagenesOriginalesCargadas: this.props.dataArticulo.cantidadImagenesOriginalesCargadas}, this.actualizarImaganesOriginalesArticulo)
        }

    }


    handleOnNombre = (e)  => {
        let articulo = {...this.state.articulo}
        articulo.nombre = e.target.value 
        this.setState({
            articulo:articulo
        })
    }

    handleOnCodigoInterno = (e)  => {
        let articulo = {...this.state.articulo}
        articulo.codigoInterno = e.target.value 
        this.setState({
            articulo:articulo
        })
    }

     
    handleOnPrecio = (precio) =>{
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.precio = precio;                        
        this.setState({articulo:articulo});
    }


    handleOnSubrubro = (e)  => {
        let articulo = {...this.state.articulo}
        articulo.idSubrubro = e.target.value 
        this.setState({
            articulo:articulo
        })
    }

    handleOnStock = (e)  => {
        let articulo = {...this.state.articulo}
        articulo.stock = e.target.value 
        articulo.stockGenerico = e.target.value
        this.setState({
            articulo:articulo
        })
    }


    handleOnDropFile = (acceptedFiles, rejectedFiles) => {        
        
        //let newImgSrc = [...this.state.articulo.imgSrc]
        
        if (rejectedFiles.length > 0) {
            Notification.showError("Archivo de imagen incompatible.")
        }
        else{
            if (acceptedFiles.length > 0) {

                // por cada imagen seleccionada
                acceptedFiles.map((item) => {
                    let currentFile = item     
                    
                    // genero una imagen para conocer sus dimesiones
                    let _self = this
                    let img = new Image()
                    img.onload = function () {
                        
                        // comprimo la imagen
                        //let newSize = calculateNewSize(this.width, this.height, 750, 750)
                        let newSize = calculateNewSize(this.width, this.height, 750*2, 1125*2) //*2 para aumentar la calidad
                        compress(currentFile, currentFile.name, newSize.width, newSize.height, _self.onImageCompressed)
                    }
                    img.src = URL.createObjectURL(currentFile)
                })
            } 
        }            
    }

    onImageCompressed = (currentFile) => {
        
        // genero una URL para el archivo    
        let file = URL.createObjectURL(currentFile)       
        
        // subo la imagen al servidor
        let payload = { currentFile: currentFile, idTemporal: this.state.idTemporal }
        this.props.sagaSaveArticuloImagen(payload)

        //Agrego un prefijo para poder obtenerla luego. En la imagenHelper le agrego el prefijo antes de guardar, ya que el campo name del currentFile es read only
        let newImgSrc = [...this.state.articulo.imgSrc]
        newImgSrc.push({path: "original_"+currentFile.name, pathImagen: file, selected: false, idArticuloImagenes:0, orden: this.state.articulo.imgSrc.length > 0 ? this.state.articulo.imgSrc.length +1 : 1, Miniatura: false})
        
        let myCurrentFiles = {...this.state.currentFiles}
        myCurrentFiles["original_"+currentFile.name] = file


        // actualizo el estado
        this.setState({
            ...this.state, 
            articulo: {
                ...this.state.articulo,
                imgSrc: newImgSrc 
            },
            currentFiles: myCurrentFiles
        })
    }

    handleCheckboxChange = (i, event) =>{
        
        let  imgSrc = this.state.articulo.imgSrc
        imgSrc[i.i].selected = !this.state.articulo.imgSrc[i.i].selected
        imgSrc[i.i].miniatura = imgSrc[i.i].selected
        let articulo = Object.assign({}, this.state.articulo);    
        articulo.imgSrc = imgSrc;                        
        this.setState({articulo:articulo});             
    }
    
    handleOnChangeOrderArticuloImagenes = (from,to) =>{
        let articulo = {...this.state.articulo} 
        let aux = to
        let auxImg = articulo.imgSrc[to]
        articulo.imgSrc[to] = articulo.imgSrc[from]
        articulo.imgSrc[from] = auxImg
        articulo.imgSrc[to].orden = aux + 1 //orden es 1 indice mayor al indice del arreglo, ya que el array empieza en 0
        articulo.imgSrc[from].orden = from + 1
        
        this.setState({
            articulo:articulo
        })
    }

    handleEliminarImagenArticulo = (indice) => {        
        //Guardo el articulo en una variable
        let articulo = {...this.state.articulo}
        let imagenes = []
        //Armo arreglo de imagenes sin la imagen a eliminar
            for(let i=0; i < articulo.imgSrc.length; i++){
                if(i !== indice){
                    imagenes.push(articulo.imgSrc[i])
                }
            }
            //seteo el nuevo arregle de imagenes al articulo
            articulo.imgSrc = imagenes
            //guardo el estadol
            this.setState({ 
                articulo: articulo,
            })
    }

    handleOnOpenCropperModal = (articuloImagen) => {
       
        if(articuloImagen === undefined)
            return

        // trato de recuperar la imagen original
        let imgPath = articuloImagen.path
        let position = imgPath.search("original_")
        let imagen 
        let pathRecorteActual = imgPath
        
        if(position === 0){
            imagen = this.state.currentFiles[imgPath]
        }
        else
        {
            let path = 'original_' + imgPath
            pathRecorteActual = path
            imagen = this.state.currentFiles[path]
        }

        // si aún no recuperamos la imagen original, la busco
        if(imagen === undefined)
        {
            // // evito llamadas recursivas
            // if(this.state.articuloImagenModal !== undefined){
            //     Notification.showError('Error al recuperar la imagen')

            //     this.setState({ articuloImagenModal: undefined })
            //     return
            // }

            this.props.sagaGetArticuloImagen({ 
                idArticuloImagen: articuloImagen.idImagen, 
                recorte: false 
            })

            // guardo el artículo imagen a mostrar cuando se recupere la imagen original
            this.setState({ articuloImagenModal: articuloImagen })
        }

        // muestro el modal
        else
        {
            this.setState({
                openModalImagen: true,
                imagenOriginal: imagen,
                pathRecorteActual: pathRecorteActual
            })
        }
    }

    handleOnDescripcion = (e)  => {        
        let articulo = {...this.state.articulo}
        articulo.descripcion = e
        this.setState({
            articulo:articulo
        })
    }

    handleOnSave = () => {
        let valido = this.validar()
        if (valido.valid === false){
            this.setState({
                valid:false,
                errorDescription:valido.errorDescription,
            })
        }
        else {
            this.setState({
                valid:true,
                errorDescription:''
            })        
            
            this.handleSaveConfirmation()
        }
             
     }
    
     handleSaveConfirmation = () => {
        
        let datosRubro = Number(this.props.match.params.idRubro)
        // genero el payload
        
        let articuloAlta = {
            
            IdArticulo: (this.props.dataArticulo !== undefined && this.props.dataArticulo.articuloCompleto !== undefined) ? this.props.dataArticulo.articuloCompleto.idArticulo : 0, //para el alta
            IdInstalacion: 3,
            IdRubro: datosRubro,
            IdSubrubro: this.state.articulo.idSubrubro,
            Nombre: this.state.articulo.nombre,
            PrecioLista: this.state.articulo.precio,
            codigoInterno : this.state.articulo.codigoInterno,
            FechaRegistro: this.state.edicion === true ? this.props.dataArticulo.articuloCompleto.fechaRegistro : new Date(),
            UsuarioRegistro: this.props.usuario ? this.props.usuario.id : undefined,
            Activo: 1,
            ArticuloImagenes : this.state.articulo.imgSrc,
            Etiquetas: this.state.articulo.etiquetas,
            StockCantidad :this.state.articulo.stockGenerico,
            idTemporal: this.idTemporalEdition !== undefined ? this.idTemporalEdition :  this.state.idTemporal,
            afterSaveArticulo: this.afterSaveArticulo
        }
        // guardamos el articulo
        this.props.sagaSaveArticuloGenerico(articuloAlta)
        
        // si el usuario modificó el subrubro del articulo actualizo el catalogoCompleto en el reductor
        
        if(this.state.idSubRubroInicial !== undefined && articuloAlta.IdSubrubro !== this.state.idSubRubroInicial){
            let subRubroNuevo 
            this.props.dataSubrubro.subrubros.forEach((s) => {
                if(s.idSubrubro === articuloAlta.IdSubrubro){
                    subRubroNuevo = s
                }
            })
            let payload = {
                idArticulo: articuloAlta.IdArticulo,
                subRubroNuevo: subRubroNuevo
            }
            this.props.cambiarArticuloDeSubRubro(payload)
        }
    }

    afterSaveArticulo = () => {
        
        // actualizo el estado
        this.setState({
            saved:true,
            valid:true
        })

        Notification.showSuccess("Artículo guardado exitosamente")
        this.limpiarFiltros()
        
        if(this.props.dataArticulo && this.props.dataArticulo.filtrosArticulo){
            this.props.setFilterBusquedaArticulo(this.props.dataArticulo.filtrosArticulo)
        }
        this.props.history.push('/Articulo')
        /*
        // muestro mensaje de éxito
        if (this.props.dataArticulo !== undefined) // Modificar esto cuando se llegue al momento de crear la edicion
        {
            Notification.showSuccess("Artículo modificado exitosamente")
            this.props.history.push(`/Catalogo/catalogoEdicion/${this.props.dataCatalogo.catalogoCompleto.idCatalogo}/${this.props.dataArticulo.articuloCompleto !== undefined ? this.props.dataArticulo.articuloCompleto.idArticulo : true}`)
            //seteo articulo completo en undefined por problemas de setstate(ya que hacer al hacer click en otro articulo muchas veces quedaba cargado el anterior)
            this.props.setArticuloCompleto(undefined)
        }
        else
        {
            
            
            this.limpiarFiltros()
        }
        */
    }

    limpiarFiltros = () => {       
         
        let articulo = {...this.state.articulo}
        articulo.nombre = ''
        articulo.precio= ''
        articulo.stock = []
        articulo.stockGenerico = ''
        articulo.imgSrc = []
        articulo.codigoInterno = ''
        articulo.descripcion = '' 
        articulo.etiquetas = []
        
        this.setState({
            articulo:articulo,
            clearState: true
        })
    }

    validar = () => { 
        let articulo = {...this.state.articulo}
        let valid = true
        let errorDescription = {}
        
        if (articulo.nombre === '' ){     
                    valid=false
                    errorDescription.errorNombre="Por favor ingrese un nombre válido"
                    
            }
        
            if (articulo.nombre.length > 255 ){     
                valid=false
                errorDescription.errorNombre="Por favor ingrese un nombre válido"
                Notification.showError("Nombre con demasiados caracteres.")
        }    
        
        if (articulo.precio === '' || isNaN(articulo.precio)){
                    valid = false
                    errorDescription.errorPrecio = "Por favor ingrese un precio válido"
                    }

        if (articulo.precio.length > 255){
                    valid = false
                    errorDescription.errorPrecio = "Por favor ingrese un precio válido"
                    Notification.showError("Precio con demasiados caracteres.")
                    }            
        
        if (articulo.idSubrubro === 0){
                        valid = false
                        errorDescription.errorSubrubro = "Por favor ingrese un subrubro"
                        }

        /*if (articulo.imgSrc.length === 0){       
                        valid=false
                        errorDescription.errorImagen="Por favor ingrese al menos una imagen"
                        Notification.showError("Por favor ingrese al menos una imagen")
                        }*/

        this.setState({articulo:articulo})
        return {valid, errorDescription}
        }
        
        handleOnCloseCropperModal = () => {          
            this.setState({openModalImagen:false})
        }
    
        onChangeFalseEditorState = () => {
            
            this.setState({
                clearState:false
            })
        }



        
        onArticuloImageCompressed = (currentFile) => {
            
            //IMAGEN ARTICULO
            let payload = {}
            payload.file = currentFile
            payload.idTemporal = this.state.idTemporal 
            
            //guardo recorte en temporal
            this.props.sagaSaveArticuloImagenRecorte(payload)
            
            // genero una URL para el recorte y el nombre del archivo
            let recorte = URL.createObjectURL(currentFile)
            let path = this.state.pathRecorteActual.split('original_')
    
            //actualizo el articulo colocando el recorte en lugar de la imagen/recorte anterior 
            let newImgSrc = [...this.state.articulo.imgSrc]
            newImgSrc.forEach((i)=>{
                if(i.path === this.state.pathRecorteActual)
                {
                    i.path = path[1]
                    i.pathImagen = recorte
                }
                else
                {
                    if(i.Path === path[1] || i.path === path[1]){
                        i.path = path[1]
                        i.pathImagen = recorte
                    }
                }
            })
    
            //seteo el recorte al estado y cierro modal
            this.setState({
                ...this.state, 
                articulo: {
                    ...this.state.articulo,
                    imgSrc: newImgSrc 
                },
                openModalImagen: false,
            });
        }

        handleOnSaveImagenCortada = (recorte, blobData, imageData) => {
            
            //IMAGEN TALLECOLOR
            if(this.state.openModalImagenTalleColor)
            {
                // obtengo el nombre de archivo
                let fileName = this.state.pathTalleColor
    
                // comprimo la imagen
                let newSize = calculateNewSize(imageData.width, imageData.height, 30, 30)
                compress(blobData, fileName, newSize.width, newSize.height, this.onTalleColorImagenCompressed)
            }
    
            else
            {
                // obtengo el nombre de archivo
                let fileName = this.state.pathRecorteActual.split('original_')[1]
    
                // comprimo la imagen
                //let newSize = calculateNewSize(imageData.width, imageData.height, 350, 525)
                let newSize = calculateNewSize(imageData.width, imageData.height, 350*2, 525*2) // el *2 es para aumentar la calidad
                
                //tomo el blob
                fetch(recorte)
                .then(r => r.blob())
                .then(r=>{compress(r, fileName, newSize.width, newSize.height, this.onArticuloImageCompressed)})
            }
        }
        
        
        handleOnCancel = () => {
            if(this.props.dataArticulo && this.props.dataArticulo.filtrosArticulo){
                this.props.setFilterBusquedaArticulo(this.props.dataArticulo.filtrosArticulo)
            }

            this.props.history.push('/Articulo')
        };

        getImagenesArticulo = () => {
            let articulo = this.props.dataArticulo.articuloCompleto
            // busco los recortes de las imágenes de los articulos
            for(var i=0; i<articulo.listaImagenesArticulos.length; i++){
                
                let idImagen = articulo.listaImagenesArticulos[i].idImagen
                let flag = true
                //Si la imagen ya existe en el reductor seteo flag en false y no se vuelve a pedir
                if(this.props.imagenesArticulo !== undefined ){
                    this.props.imagenesArticulo.forEach((ai) => {
                        if(ai.idArticuloImagen === idImagen){
                            flag = false
                        }
                    })
                }
                //busco la imagen segun el flag 
                if(flag){
                    this.props.sagaGetArticuloImagen({ 
                        idArticuloImagen: articulo.listaImagenesArticulos[i].idImagen, 
                        recorte: true 
                    })
                }
            }
    
        }

    handleDelete = (etiqueta) => {
        let articulo = {...this.state.articulo}

        articulo.etiquetas = articulo.etiquetas.filter(x => x.etiqueta !== etiqueta)
        this.setState({articulo: articulo})
    }    

    handleOnCampoEtiqueta = (e) => {
        let value = e.target.value 

        this.setState({campoEtiqueta:value})
    }

    handleOnAddEtiqueta = () => {
        if(this.state.campoEtiqueta === undefined || this.state.campoEtiqueta === "" || this.state.campoEtiqueta === null){
            return
        }
        
        let value = this.state.campoEtiqueta
        let articulo = {...this.state.articulo}

        let e = articulo.etiquetas.find(x => x.etiqueta === value)
        if(e === undefined){
            let etiqueta = {}
            etiqueta.etiqueta = value
            etiqueta.etiquetaManual = true
            articulo.etiquetas.push(etiqueta)

            this.setState({articulo: articulo, campoEtiqueta: ''})
        }
    }

    render() {

        return(
            <ArticuloGenericoNuevo 
                articulo = {this.state.articulo}
                rubros = {this.props.rubros}
                match = {this.props.match}
                subrubros= {this.props.dataSubrubro.subrubros} 
                campoEtiqueta={this.state.campoEtiqueta}
                handleOnNombre = {this.handleOnNombre}
                handleOnPrecio = {this.handleOnPrecio}
                handleOnCodigoInterno = {this.handleOnCodigoInterno}
                handleOnSubrubro = {this.handleOnSubrubro}
                handleOnStock = {this.handleOnStock}
                handleOnDropFile = {this.handleOnDropFile}
                handleCheckboxChange = {this.handleCheckboxChange}
                handleEliminarImagenArticulo = {this.handleEliminarImagenArticulo}
                handleOnOpenCropperModal = {this.handleOnOpenCropperModal}
                handleOnCloseCropperModal = {this.handleOnCloseCropperModal}
                handleOnChangeOrderArticuloImagenes = {this.handleOnChangeOrderArticuloImagenes}
                handleOnDescripcion = {this.handleOnDescripcion}
                handleOnSave = {this.handleOnSave}
                handleOnCancel = {this.handleOnCancel}
                handleDelete={this.handleDelete}
                handleOnCampoEtiqueta={this.handleOnCampoEtiqueta}
                handleOnAddEtiqueta={this.handleOnAddEtiqueta}
                articuloEdicion = {this.props.dataArticulo.articuloCompleto}

                esEdicion={this.props.match && this.props.match.params && this.props.match.params.idArticulo ? true : false}

                clearState = {this.state.clearState}
                valid = {this.state.valid}
                errorDescription = {this.state.errorDescription}
                onChangeFalseEditorState = {this.onChangeFalseEditorState}
                openModalImagen = {this.state.openModalImagen}
                imagenOriginal = {this.state.imagenOriginal}
                handleOnSaveImagenCortada = {this.handleOnSaveImagenCortada}
                />

        )
    }
}


function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        
        ...rubrosActions,
        ...articuloActions
	}, dispatch)
}


function mapStateToProps(state) {
	return {
        rubros: rubrosDataSelector(state),
        dataArticulo: articuloDataSelector(state),
        dataSubrubro: rubrosDataSelector(state),
        imagenesArticulo: state.articuloReducer.getIn(["data", "articuloImagenes"]).toJS(),
        usuario: usuarioSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticuloGenericoNuevoContainer)